import { render, staticRenderFns } from "./formAtex.vue?vue&type=template&id=0aa2a338&"
import script from "./formAtex.vue?vue&type=script&lang=js&"
export * from "./formAtex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports